import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import CollapseButton from '../../components/Filter/CollapseButton';
import FilterPanel from '../../components/Filter/FilterPanel';
import { messages } from '../Filter/Filter.i18n';
import { toggleFilterPanel, filterOptionsChanged } from '../../redux/modules/test-results/test-results-action-creators';
import { getDefaultFilter } from '../../redux/modules/test-results/test-results-reducer';
import { messages as testResultMessages } from './TestResults.i18n';
import { dateButtonGroupConfig,
  providerDropdownConfig,
  typeDropdownConfig,
}
  from '../../containers/TestResults/FilterConfig';

class TestResultsFilters extends Component {
  constructor() {
    super();
    this.handleCollapseEventBound = this.handleCollapseEvent.bind(this);
  }

  handleCollapseEvent() {
    this.props.dispatch(toggleFilterPanel(!this.props.showFilterPanel));
  }

  render() {
    const { formatMessage } = this.props.intl;
    const filterValues = [
      {
        id: 'type-filter',
        ref: 'testProcedurefilter',
        list: typeDropdownConfig(this.props, formatMessage),
        label: testResultMessages.filter.testProcedure,
        xsSize: 12,
        smSize: 6,
        mdSize: 3,
      },
      {
        id: 'order-by-filter',
        ref: 'orderbyfilter',
        list: providerDropdownConfig(this.props, formatMessage),
        label: testResultMessages.filter.orderedBy,
        xsSize: 12,
        smSize: 6,
        mdSize: 3,
      },
    ];
    const dateValues = dateButtonGroupConfig(this.props, formatMessage);

    // Show empty space if the store does not have any initial state values.
    if (!this.props.filterOptions) {
      return null;
    }

    let messageElement = null;
    if (this.props.filter.date !== 'All' ||
        this.props.filter.testProcedure.length !== 0 ||
        this.props.filter.orderedBy.length !== 0) {
      messageElement = (<FormattedMessage
        { ...messages.filter.filterMessage }
        values={{
          filteredRows: this.props.filteredRows || '0',
          allRows: this.props.allRows || '0',
          rowItemName: <span className="hidden-xs">&nbsp;{
            formatMessage(testResultMessages.filter.testResults)
          }
                       </span>,
        }}
      />);
    }

    return (
      <div>
        <CollapseButton
          isOpen={this.props.showFilterPanel}
          onClick={this.handleCollapseEventBound}
          variant="outline-secondary mb-2"
          icon="fa-solid fa-filter mr-1"
        />
        <div className="collapse-button-info">
        { messageElement }
        </div>
        <FilterPanel isOpen={this.props.showFilterPanel}
          createFilterChangeAction={filterOptionsChanged}
          filterValues={filterValues}
          dateValues={dateValues}
          filter={this.props.filter}
          keyDateFilterPreference="PatientPortal_LabResultFilter_Date"
          clearFilter={getDefaultFilter()}
        />
      </div>
    );
  }
}

TestResultsFilters.propTypes = {
  dispatch: PropTypes.func,
  filterOptions: PropTypes.object,
  filter: PropTypes.object,
  intl: PropTypes.object,
  showFilterPanel: PropTypes.bool,
  filteredRows: PropTypes.number,
  allRows: PropTypes.number,
  allResults: PropTypes.array,
  defaultDateFilterValue: PropTypes.string,
};

const mapStateToProps = (state) => ({
  filterOptions: state.testResults.filterOptions,
  filter: state.testResults.filter,
  showFilterPanel: state.testResults.showFilterPanel,
  defaultDateFilterValue: state.profile.user.preferences.PatientPortal_LabResultFilter_Date,
});

export default connect(mapStateToProps)(injectIntl(TestResultsFilters));